{
  "title": "API-ключі",
  "description": "Особисті ключі, які дають ШІ-помічнику змогу створювати навчальні матеріали у цій школі через MCP-сервер Osvitly. Створені ключем матеріали лишаються чернетками, доки ви не опублікуєте їх самі; створений клас лишається порожнім, доки ви не зарахуєте учнів.",
  "keys": {
    "title": "Ключі",
    "name": "Назва",
    "prefix": "Префікс",
    "owner": "Діє як",
    "created": "Створено",
    "lastUsed": "Востаннє використано",
    "neverUsed": "Ніколи",
    "status": "Стан",
    "empty": "Ключів ще немає.",
    "emptyTeacher": "У вас ще немає ключів.",
    "loadFailed": "Не вдалося завантажити ключі.",
    "states": {
      "active": "Активний",
      "paused": "Призупинено",
      "revoked": "Відкликано"
    }
  },
  "create": {
    "trigger": "Новий ключ",
    "title": "Створити API-ключ",
    "description": "Ключ буде показано один раз — одразу після створення. Збережіть його в надійному місці, перш ніж закрити це вікно.",
    "name": "Назва",
    "namePlaceholder": "Claude на моєму ноутбуку",
    "nameHint": "Підказка собі: на якому пристрої чи в якому інструменті зберігається цей ключ.",
    "nameRequired": "Вкажіть назву ключа.",
    "nameTooLong": "Не більше ніж 50 символів.",
    "owner": "Діє як",
    "ownerHint": "Ключ може робити те саме, що й цей учасник, і кожна зміна записується на нього.",
    "ownerSelf": "Ви",
    "ownerSelfOnly": "Ключ особистий: він діятиме від вашого імені.",
    "submit": "Створити ключ",
    "failed": "Не вдалося створити ключ."
  },
  "reveal": {
    "title": "Скопіюйте ключ зараз",
    "warning": "Це єдиний раз, коли ключ показано. Він зберігається у вигляді хешу, тож побачити його знову неможливо — якщо загубите, відкличте цей і створіть новий.",
    "label": "API-ключ",
    "copy": "Скопіювати ключ",
    "copied": "Ключ скопійовано в буфер обміну.",
    "copyFailed": "Не вдалося скопіювати — виділіть ключ і скопіюйте вручну.",
    "howTo": "Як його використати",
    "howToIntro": "Додайте MCP-сервер у Claude Code:",
    "howToNote": "Для локального стека вкажіть http://localhost:8000/api як адресу API.",
    "acknowledge": "Ключ збережено"
  },
  "revoke": {
    "action": "Відкликати",
    "title": "Відкликати «{{name}}»?",
    "description": "Ключ перестане працювати негайно, і відновити його не можна. Журнал його дій залишиться, тож запис про зміни збережеться.",
    "confirm": "Відкликати ключ",
    "success": "Ключ відкликано.",
    "failed": "Не вдалося відкликати ключ."
  },
  "activity": {
    "title": "Активність MCP",
    "description": "Кожна зміна, зроблена ключем, найновіші — згори. Перегляди не фіксуються.",
    "empty": "Активності ще немає.",
    "loadFailed": "Не вдалося завантажити активність.",
    "viaKey": "через {{prefix}}",
    "noTarget": "—",
    "kinds": {
      "create": "Створено",
      "update": "Оновлено",
      "delete": "Видалено",
      "publish": "Опубліковано",
      "other": "Змінено"
    },
    "resources": {
      "course": "Курс",
      "lesson": "Урок",
      "module": "Модуль",
      "test": "Тест",
      "question": "Запитання",
      "homework": "Домашнє завдання",
      "project": "Проєкт",
      "lesson_schedule": "Урок у розкладі",
      "class": "Клас"
    }
  }
}
